import UploadScanning from './UploadScanning'

export default UploadScanning
